import React, { useRef, useState } from 'react';
import { Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { fileToDataUrl } from '../utils/imageProcessor';

interface ImageUploaderProps {
  onImageSelected: (file: File, dataUrl: string) => void;
}

const ImageUploader: React.FC<ImageUploaderProps> = ({ onImageSelected }) => {
  const [fileName, setFileName] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    console.log('选择的文件:', file.name);
    
    try {
      // 验证文件类型
      if (!file.type.match(/image\/(jpeg|png|webp)/)) {
        throw new Error('仅支持JPEG/PNG/WebP格式的图片');
      }

      // 验证文件大小 (5MB限制)
      if (file.size > 5 * 1024 * 1024) {
        throw new Error('图片大小不能超过5MB');
      }

      console.log('文件验证通过，生成预览...');
      const dataUrl = await fileToDataUrl(file);
      
      setFileName(file.name);
      onImageSelected(file, dataUrl);
      
    } catch (error) {
      console.error('文件处理失败:', error);
      message.error(error instanceof Error ? error.message : '文件处理失败');
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleClear = () => {
    setFileName(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  return (
    <div>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept="image/jpeg,image/png,image/webp"
        style={{ display: 'none' }}
      />
      
      {fileName ? (
        <div style={{ marginBottom: 16 }}>
          <span style={{ marginRight: 8 }}>{fileName}</span>
          <Button type="link" danger onClick={handleClear}>
            清除
          </Button>
        </div>
      ) : (
        <Button 
          icon={<UploadOutlined />}
          onClick={handleClick}
        >
          选择图片
        </Button>
      )}
      
      <div style={{ color: '#999', fontSize: 12, marginTop: 8 }}>
        支持JPEG/PNG/WebP格式，最大5MB
      </div>
    </div>
  );
};

export default ImageUploader;